export type Occurrence = {
	id: 1 | 2 | 4 | 8 | 16 | 32 | 64;
	text?: string;
}

export const OCCURRENCE_TYPES: Record<string, Occurrence> = {
	once: { id: 1, text: 'Once' },
	daily: { id: 4, text: 'Daily' },
	weekly: { id: 8, text: 'Weekly' },
	monthly: { id: 16, text: 'Monthly' },
};

export const EXTENDED_OCCURRENCE_TYPES: Record<string, Occurrence> = {
	once: { id: 1, text: 'Once' },
	daily: { id: 4, text: 'Daily' },
	weekly: { id: 8, text: 'Weekly' },
	monthly: { id: 16, text: 'Monthly' },
	yearly: { id: 32, text: 'Yearly' },
};

export const WEEK_OCCURRENCE_TYPES: Record<string, Occurrence> = {
	monday: { id: 2, text: 'Monday' },
	tuesday: { id: 4, text: 'Tuesday' },
	wednesday: { id: 8, text: 'Wednesday' },
	thursday: { id: 16, text: 'Thursday' },
	friday: { id: 32, text: 'Friday' },
	saturday: { id: 64, text: 'Saturday' },
	sunday: { id: 1, text: 'Sunday' },
};

export type AgentSchedule = {
	idz?: number;
	validate_flag?: boolean;
	accounting?: number;
	ord_num?: number;
	id_agent_schedule?: number;
	name?: string;
	interval?: number;
	next_run?: string;
	run_now?: boolean;
	date_created?: string;
	who_created?: string;
}

export type DbJob = {
	job_name?: string;
	new_name?: string;
	enabled?: boolean;
	description?: string;
	owner_login_name?: string;
	category_name?: string;
	category_id?: number;
	start_step_id?: number;
}

export type ETLJob = {
	accounting?: number;
	job_name?: string;
	ord_num?: number;
	id_thread_value_b?: number;
	description_value_b?: string;
	id_thread_value_i?: number;
	description_value_i?: string;
	id_thread_value_f?: number;
	description_value_f?: string;
	id_thread_value_s?: number;
	description_value_s?: string;
	id_thread_value_s2?: number;
	description_value_s2?: string;
	id_thread_value_s3?: number;
	description_value_s3?: string;
	job_type?: string;
	job_year?: number;
	params?: JobParam;
	enabled?: boolean;
	description?: string;
	last_run?: string;
	next_run?: string;
	steps?: JobStep[];
	title?: string;
	default_flag?: boolean;
	allow?: boolean;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type JobHistory = {
	job_name?: string;
	step_id?: number;
	step_name?: string;
	sql_message_id?: number;
	sql_severity?: number;
	message?: string;
	run_status?: number;
	run_date?: number;
	run_time?: number;
	run_duration?: number;
	retries_attempted?: number;
	server?: string;
}

export type JobParam = {
	idz?: number;
	date_created?: string;
	who_created?: string;
	param?: string;
	accounting?: number;
	value_b?: number;
	value_i?: number;
	value_f?: number;
	value_s?: string;
	value_s2?: string;
	value_s3?: string;
	value_d?: string;
}

export type JobSchedule = {
	job_name?: string;
	schedule_id?: number;
	name?: string;
	enabled?: number;
	freq_type?: number;
	freq_interval?: number;
	freq_subday_type?: number;
	freq_subday_interval?: number;
	freq_relative_interval?: number;
	freq_recurrence_factor?: number;
	active_start_date?: number;
	active_end_date?: number;
	active_start_time?: number;
	active_end_time?: number;
	date_created?: string;
	date_modified?: string;
	version_number?: number;
	params?: JobParam;
}

export type JobStatus = {
	job_name?: string;
	execution_time?: number;
	running?: boolean;
	running_job_name?: string;
	enabled?: boolean;
	description?: string;
	last_run?: string;
	last_run_end?: string;
	next_run?: string;
	last_run_duration?: number;
	last_run_outcome?: number;
	who_run?: string;
}

export type JobStep = {
	job_name?: string;
	step_id?: number;
	step_name?: string;
	subsystem?: string;
	command?: string;
	database_name?: string;
	on_success_action?: number;
	on_success_step_id?: number;
	on_fail_action?: number;
	on_fail_step_id?: number;
	retry_attempts?: number;
	retry_interval?: number;
}